/**
 * Router Reference
 *
 * Module-level router reference used by non-React code (API interceptors)
 * to perform programmatic navigation without needing React context.
 */

import type { AnyRouter } from '@tanstack/react-router';

let routerRef: AnyRouter | null = null;

export function setRouterRef(router: AnyRouter): void {
  routerRef = router;
}

export function getRouterRef(): AnyRouter | null {
  return routerRef;
}
